/* eslint-disable */
import React from 'react';

export type PracticeGridCardIconRender = () => React.ReactNode;

const iconProps = {
  width: 48,
  height: 48,
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};

export const PSA_PRACTICE_GRID_ICONS: PracticeGridCardIconRender[] = [
  // Airplay
  () => (
    <svg width="43" height="39" viewBox="0 0 43 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 29.5H5.5C4.43913 29.5 3.42172 29.0786 2.67157 28.3284C1.92143 27.5783 1.5 26.5609 1.5 25.5V5.5C1.5 4.43913 1.92143 3.42172 2.67157 2.67157C3.42172 1.92143 4.43913 1.5 5.5 1.5H37.5C38.5609 1.5 39.5783 1.92143 40.3284 2.67157C41.0786 3.42172 41.5 4.43913 41.5 5.5V25.5C41.5 26.5609 41.0786 27.5783 40.3284 28.3284C39.5783 29.0786 38.5609 29.5 37.5 29.5H35.5M21.5 25.5L31.5 37.5H11.5L21.5 25.5Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
   ),
  // Clipboard
  () => (
    <svg width="35" height="43" viewBox="0 0 35 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25.5 5.5H29.5C30.5609 5.5 31.5783 5.92143 32.3284 6.67157C33.0786 7.42172 33.5 8.43913 33.5 9.5V37.5C33.5 38.5609 33.0786 39.5783 32.3284 40.3284C31.5783 41.0786 30.5609 41.5 29.5 41.5H5.5C4.43913 41.5 3.42172 41.0786 2.67157 40.3284C1.92143 39.5783 1.5 38.5609 1.5 37.5V9.5C1.5 8.43913 1.92143 7.42172 2.67157 6.67157C3.42172 5.92143 4.43913 5.5 5.5 5.5H9.5M11.5 1.5H23.5C24.6046 1.5 25.5 2.39543 25.5 3.5V7.5C25.5 8.60457 24.6046 9.5 23.5 9.5H11.5C10.3954 9.5 9.5 8.60457 9.5 7.5V3.5C9.5 2.39543 10.3954 1.5 11.5 1.5Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  // Crosshair
  () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M41.5 21.5C41.5 32.5457 32.5457 41.5 21.5 41.5M41.5 21.5C41.5 10.4543 32.5457 1.5 21.5 1.5M41.5 21.5H33.5M21.5 41.5C10.4543 41.5 1.5 32.5457 1.5 21.5M21.5 41.5V33.5M1.5 21.5C1.5 10.4543 10.4543 1.5 21.5 1.5M1.5 21.5H9.5M21.5 1.5V9.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  // Disc
  () => (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.5 41.5C32.5457 41.5 41.5 32.5457 41.5 21.5C41.5 10.4543 32.5457 1.5 21.5 1.5C10.4543 1.5 1.5 10.4543 1.5 21.5C1.5 32.5457 10.4543 41.5 21.5 41.5Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.5 27.5C24.8137 27.5 27.5 24.8137 27.5 21.5C27.5 18.1863 24.8137 15.5 21.5 15.5C18.1863 15.5 15.5 18.1863 15.5 21.5C15.5 24.8137 18.1863 27.5 21.5 27.5Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  // File plus
  () => (
    <svg width="35" height="43" viewBox="0 0 35 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33.5 13.5L21.5 1.5H5.5C4.43913 1.5 3.42172 1.92143 2.67157 2.67157C1.92143 3.42172 1.5 4.43913 1.5 5.5V37.5C1.5 38.5609 1.92143 39.5783 2.67157 40.3284C3.42172 41.0786 4.43913 41.5 5.5 41.5H29.5C30.5609 41.5 31.5783 41.0786 32.3284 40.3284C33.0786 39.5783 33.5 38.5609 33.5 37.5V13.5ZM21.5 1.5V13.5H33.5M17.5 33.5V21.5M11.5 27.5H23.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
];

export const TPV_PRACTICE_GRID_ICONS: PracticeGridCardIconRender[] = [
  // Search
  () => (
    <svg {...iconProps}>
      <circle cx="21" cy="21" r="14" stroke="currentColor" strokeWidth="2.5" />
      <path
        d="M31 31L42 42"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  // Save
  () => (
    <svg {...iconProps}>
      <path
        d="M8 8H34L40 14V40C40 41.1046 39.1046 42 38 42H10C8.89543 42 8 41.1046 8 40V8Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 8V18H16V8"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="14"
        y="26"
        width="20"
        height="12"
        rx="1"
        stroke="currentColor"
        strokeWidth="2.5"
      />
    </svg>
  ),
  // Settings
  () => (
    <svg {...iconProps}>
      <circle cx="24" cy="24" r="6" stroke="currentColor" strokeWidth="2.5" />
      <path
        d="M24 4V8M24 40V44M4 24H8M40 24H44M10.34 10.34L13.17 13.17M34.83 34.83L37.66 37.66M10.34 37.66L13.17 34.83M34.83 13.17L37.66 10.34"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  // Server
  () => (
    <svg {...iconProps}>
      <ellipse cx="24" cy="14" rx="16" ry="6" stroke="currentColor" strokeWidth="2.5" />
      <path
        d="M8 14V26C8 29.3137 15.1634 32 24 32C32.8366 32 40 29.3137 40 26V14"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path
        d="M8 26V38C8 41.3137 15.1634 44 24 44C32.8366 44 40 41.3137 40 38V26"
        stroke="currentColor"
        strokeWidth="2.5"
      />
    </svg>
  ),
  // Package
  () => (
    <svg {...iconProps}>
      <path
        d="M24 4L42 14V34L24 44L6 34V14L24 4Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M24 24L42 14M24 24L6 14M24 24V44"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
];
